import apiClient from './apiClient';
import { GET_TOUR_TYPE_URL } from './apiUrl';

const getTourTypeApi = () => {
  return apiClient.get(GET_TOUR_TYPE_URL);
};

export default getTourTypeApi;
